export interface TreeTooltipList {
    [attribute: string]: TreeTooltip;
}

export interface TreeTooltip {
    class: string;
    tooltipText: string;
    text?: string;
    materialIcon?: string;
    materialIconClass?: string;
    isPreloader?: boolean;
}

export enum TreePreloaderType {
    REFRESH_DATA = '$refreshData',
    ADD_DEVICE = '$addDevice',
    REMOVE_DEVICE = '$removeDevice',
}
